export function getIV(length: number): Uint8Array {
    // https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues :
    // The Crypto.getRandomValues() method lets you get cryptographically strong random values.
    return crypto.getRandomValues(new Uint8Array(length));
}
